import ShoppingBagIcon from "@redotech/redo-icons/shopping-bag-01.svg";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { NumberFilterOperator } from "@redotech/redo-model/views/advanced-filters/number-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const FulfillmentOrderCountFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.NUMBER,
  Icon: ShoppingBagIcon,
  min: 0,
  data: {
    name: "fulfillmentOrderCount",
    type: AdvancedFilterType.NUMBER,
    value: null,
    operator: NumberFilterOperator.GREATER_THAN,
  },
  displayName: "Order count",
};
